import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import { AuthProvider } from "./src/context/AuthContext";
import { UsageProvider } from "./src/context/UsageContext";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => (
  <AuthProvider>
    <UsageProvider>{element}</UsageProvider>
  </AuthProvider>
);
